import { RouterModule } from '@angular/router';
import { inject, signal, Component, ChangeDetectionStrategy } from '@angular/core';

import { AuthStore } from '@/app/core/store/auth';
import { SessionService } from '@/app/core/services/session';

import { ButtonComponent } from '@/app/shared/components/ui/button';
import { SvgIconComponent } from '@/app/shared/components/ui/svg-icon';
import { NavigationMenuItem, NavigationMenuComponent } from '@/app/shared/components/navigation-menu';

@Component({
  selector: 'app-header',
  imports: [RouterModule, NavigationMenuComponent, ButtonComponent, SvgIconComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  private authStore = inject(AuthStore);
  private sessionService = inject(SessionService);

  isLoggingOut = signal(false);

  readonly navLinks: NavigationMenuItem[] = [
    {
      label: 'Clients list',
      link: ['/clients'],
      permissions: ['view_clients'],
    },
    {
      label: 'Team management',
      link: ['/team-management'],
      permissions: ['view_users'],
    },
  ];

  get authUser() {
    return this.authStore.authUser;
  }

  logout() {
    if (this.isLoggingOut()) {
      return;
    }

    this.isLoggingOut.set(true);

    this.sessionService.logout().subscribe();
  }
}
